import { defineComponent as _defineComponent } from 'vue'
import LoadSpinner from '../../../vuecomponents/LoadingSpinnerAntPanels.vue';
import TaskGroupCard from './GroupCard.vue';

import { GetCardProjectionsForUser, GetPortalTasksForUser, GetUserName} from '../../../src/WorkControllerApiClient';
import { ref, onMounted, Ref } from 'vue';
import * as Sorting from './cardSorting';
import { GenerateCardsFromTasks } from './cardSorting';
import Resource from '../../../src/resources/Resource.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {
  expose();

let DoneLoading = ref(false);

let GroupMethod = ref(Sorting.GroupBy.WorkItemId);
let SortMethod = ref(Sorting.SortBy.LastUpdated);

let PortalTasks: Ref<IPortalTaskDTO[]> = ref([]);
let TaskProjections: Ref<ITaskCardProjectionDTO[]> = ref([]);
let UserName: Ref<string> = ref("");

onMounted(async () => {
    let portalTasks = GetPortalTasksForUser();
    let projections = GetCardProjectionsForUser();
    let userName = GetUserName();

    Promise.all([portalTasks, projections, userName]).then((values) => {
        PortalTasks.value = values[0];
        TaskProjections.value = values[1];
        UserName.value = values[2];
        DoneLoading.value = true;
    });
});

const __returned__ = { DoneLoading, GroupMethod, SortMethod, PortalTasks, TaskProjections, UserName, LoadSpinner, TaskGroupCard, GenerateCardsFromTasks, Resource }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})